import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const IonicappServices: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 gap-5 md:gap-5 lg:gap-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
              At Moweb, our developers strive hard to transform your ideas into tangible entities with robust and scalable applications. We leverage a range of ionic mobile app development services to all industries an clientele globally which includes:
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Ionic UI Design" />
            <KEYBlue text="Ionic Mobile App Development" />
            <KEYBlue text="Ionic App Testing" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Ionic App Integration" />
            <KEYBlue text="Ionic App Porting" />
            <KEYBlue text="Ionic Support & Maintenance" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default IonicappServices
